import { createFileRoute } from '@tanstack/react-router';

import { dashboardScreen, loadDashboardMessages, loadDashboardScreens } from '@/modules/dashboard/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// `/dashboard`: o caminho do Dashboard no legado com `INITIAL_ROUTE` (router.tsx:305-313); o `/` é o Início.
export const Route = createFileRoute('/_app/dashboard/')({
  staticData: { screen: dashboardScreen },
  loader: () => loadDashboardMessages(),
  component: lazyScreen(loadDashboardScreens, 'DashboardRouteScreen'),
});
